module.exports = __webpack_public_path__ + "img/second_wave_bottom.79a963d9.svg";